// extracted by mini-css-extract-plugin
export default {"tabList":"styles_tabList__vosZY","tabButton":"styles_tabButton__6FCvR","tabButtonActive":"styles_tabButtonActive__iQKZi"};